import { call, put, takeEvery } from "redux-saga/effects";
import { message } from 'antd';
import responseRate from '../Actions/responseRate';
import { getServiceResponseRate as getServiceResponseRateRequest } from '../Api/ResponseRate';

const { types, actions } = responseRate;
const { getServiceResponseRateSuccess, getServiceResponseRateError } = actions;

export function* getServiceResponseRate() {
    try {
        const response = yield call(getServiceResponseRateRequest);
        if (response && response.status === 'success' && response.data !== null) {
            yield put(getServiceResponseRateSuccess(response.data));
        } else {
            yield put(getServiceResponseRateError('Error al obtener la tasa de respuesta'));
            message.error('Error al obtener la tasa de respuesta del servicio', 5);
        }
    } catch (error) {
        yield put(getServiceResponseRateError(error.message));
        message.error(error.message, 5);
    }
}

export function* responseRateSaga() {
    yield takeEvery(types.GET_SERVICE_RESPONSE_RATE, getServiceResponseRate);
}

